import axiosRequest from '../constants/axios-request'
import { Part, Question } from '../types/training'

export const getPart = (partId: string | undefined): Promise<Part> =>
  axiosRequest.get(`/part/${partId}`).then((result) => result.data)

export const addQuestion = (payload: {
  question: Omit<Question, 'id'>
  partId: string
}): Promise<number> =>
  axiosRequest
    .post(`/question`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const updateQuestion = (
  questionId: string,
  payload: Omit<Question, 'id'>
): Promise<number> =>
  axiosRequest
    .put(`/question/${questionId}`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const updateTextPart = (
  partId: string,
  payload: { text: string }
): Promise<number> =>
  axiosRequest
    .put(`/part/${partId}`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const deleteQuestion = (
  questionId: string | undefined
): Promise<number> =>
  axiosRequest
    .delete(`/admin/question/${questionId}`)
    .then((result) => result.status)
    .catch((error) => error.response.status)
